import React, { useEffect, useState } from "react";
import { StyleSheet, TouchableOpacity } from "react-native";

import Icon from "components/Icon";
import Text from "components/Text";

import { colors, sizes } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import { mq } from "utils";

export default function CheckBox(props: CheckBoxT) {
  const auth = useRecoilValue(authAtom);

  const { title, value, onChange, onPress } = props;

  const [innerValue, setValueState] = useState(value);
  useEffect(() => {
    setValueState(value);
  }, [value]);

  const _innerOnChange = () => {
    const newValue = innerValue === 0 ? 1 : 0;
    onChange && onChange(newValue);
    setValueState(newValue);
  };

  const color =
    innerValue === 1
      ? auth?.company?.color ?? colors.theme
      : colors.textColorGray;
  const icon = innerValue === 1 ? "check-square" : "square";
  return (
    <TouchableOpacity
      onPress={onPress ? onPress : _innerOnChange}
      activeOpacity={sizes.tapOpacity}
      style={styles.container}
    >
      <Icon name={icon} color={color} />
      <Text color={color} size="lg" style={{ bottom: mq(3) }}>
        {" "}
        {title}
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row-reverse",
    alignSelf: "flex-end",
  },
});
